import {
  combineSentences, stringContainsOther, addFullStopIfNoPunctionationAtEnd
} from './common';
import CONFIG from '@/config/global';

export const createGenrePageTitle = ({ genre, isViewingNewShows = false } = {}) => {
  const { title } = genre || {};

  if (!title) { return ''; }

  return `${ isViewingNewShows ? 'New ' : '' }${ title } on ${ CONFIG.appName }`;
};

const createOriginDescriptionText = ({ description, origin } = {}) => {
  if (!origin) {
    return '';
  }

  const descriptionContainsOrigin = stringContainsOther(description, origin);
  const descriptionContainsWordOrigin = stringContainsOther(description, 'Origin');
  const originIsWorldwide = stringContainsOther(origin, 'Global')
    || stringContainsOther(origin, 'World');

  const originDescription = (
    origin
    && !originIsWorldwide
    && !descriptionContainsWordOrigin
    && !descriptionContainsOrigin
  )
    ? `Originating from ${ origin }.`
    : '';

  return originDescription;
};

const createParentTitleDescriptionText = ({ description, parentTitle } = {}) => {
  if (!parentTitle) {
    return '';
  }

  const descriptionContainsParentTitle = stringContainsOther(description, parentTitle);

  const parentTitleDescription = (parentTitle && !descriptionContainsParentTitle)
    ? `Subgenre of ${ parentTitle }.`
    : '';

  return parentTitleDescription;
};

export const createGenrePageDescription = ({ genre, augmentDescription = false } = {}) => {
  const {
    description, features, parent
  } = genre || {};

  if (!description) {
    return '';
  }

  const { key_location } = features || {};
  const { title: parentTitle } = parent || {};

  const formattedDescription = addFullStopIfNoPunctionationAtEnd(description);

  if (!augmentDescription) {
    return formattedDescription;
  }

  return combineSentences([
    formattedDescription,
    createOriginDescriptionText({
      description,
      origin: key_location
    }),
    createParentTitleDescriptionText({
      description,
      parentTitle
    })
  ]);
};